"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("../../../common/Modal/Modal"));
var _APLabelWithText = _interopRequireDefault(require("../../../common/APLabelWithText"));
var _APIcon = _interopRequireDefault(require("../../../common/APIcon"));
var _dateHelper = require("../../../../helpers/dateHelper");
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
var _formTemplateHelper = require("../../../../helpers/formTemplateHelper");
require("./FiatDepositModalComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var fiatDepositModalClasses = (0, _cssClassesHelper.getBEMClasses)('fiat-deposit-modal');
var shouldRenderBankInfo = function shouldRenderBankInfo(bankInfo) {
  return bankInfo.name && bankInfo.wireNumber && bankInfo.accountNumber;
};
var FiatDepositModalComponent = function FiatDepositModalComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  var _props$payload = props.payload,
    ProductSymbol = _props$payload.ProductSymbol,
    fullname = _props$payload.fullname,
    amount = _props$payload.amount,
    comments = _props$payload.comments,
    GivenName = _props$payload.GivenName,
    Amount = _props$payload.Amount,
    template = props.template,
    _props$templateInfo = props.templateInfo,
    templateInfo = _props$templateInfo === void 0 ? {} : _props$templateInfo,
    payload = props.payload;
  var templateFields = (0, _formTemplateHelper.templateConfirmRenderer)(template, payload, fiatDepositModalClasses, {
    t: t
  });
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: props.isOpen,
    title: /*#__PURE__*/_react["default"].createElement("div", {
      className: fiatDepositModalClasses('header-content')
    }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
      name: 'depositWithBorder',
      size: 44,
      customClass: fiatDepositModalClasses('icon')
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: fiatDepositModalClasses('header-title')
    }, "".concat(t('Deposit'), " ").concat(ProductSymbol))),
    close: props.close,
    footer: {
      buttonText: t('Confirm'),
      buttonStyle: 'additive',
      onClick: function onClick() {
        props.submitDeposit(payload);
        if (props.showDepositIdModal) {
          props.openReferenceModal();
        }
      }
    },
    customClass: fiatDepositModalClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: fiatDepositModalClasses('title')
  }, t('Confirmation')), /*#__PURE__*/_react["default"].createElement("div", {
    className: fiatDepositModalClasses()
  }, templateFields.length > 0 ? templateFields : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Full Name'),
    text: fullname || GivenName,
    customClass: fiatDepositModalClasses()
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Amount to Deposit'),
    text: amount || Amount,
    customClass: fiatDepositModalClasses()
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Note'),
    text: comments || '-',
    customClass: fiatDepositModalClasses()
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Time'),
    text: (0, _dateHelper.formatDateTime)(new Date()),
    customClass: fiatDepositModalClasses()
  })), templateInfo.DepositWorkflow === 'ManualDeposit' && shouldRenderBankInfo(props.bankInfo) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: fiatDepositModalClasses('bank-info')
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Step 2: Wire the funds to this account'),
    customClass: fiatDepositModalClasses(),
    classModifiers: "bank-info"
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Bank Name:'),
    text: props.bankInfo.name,
    customClass: fiatDepositModalClasses(),
    classModifiers: "bank-info"
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Wire Number:'),
    text: props.bankInfo.wireNumber,
    customClass: fiatDepositModalClasses(),
    classModifiers: "bank-info"
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Account Number:'),
    text: props.bankInfo.accountNumber,
    customClass: fiatDepositModalClasses(),
    classModifiers: "bank-info"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: fiatDepositModalClasses('information')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: fiatDepositModalClasses('information-text')
  }, t('Make sure the wire transfer matches the Name and Amount stated in this Deposit Ticket.')), /*#__PURE__*/_react["default"].createElement("div", {
    className: fiatDepositModalClasses('information-text')
  }, t('A copy of this Deposit Ticket will be emailed to you'))))));
};
FiatDepositModalComponent.propTypes = {
  payload: _propTypes["default"].object,
  close: _propTypes["default"].func.isRequired
};
FiatDepositModalComponent.defaultProps = {
  payload: {
    fullname: '',
    amount: '',
    comments: ''
  }
};
var _default = exports["default"] = FiatDepositModalComponent;